import { PrescriptionUploadHost } from '@/entities/prescription/components/PrescriptionUploadHost';
import { Gnb } from '@/layouts/Gnb';
import { useAuthStore } from '@/stores/authStore';
import { Outlet } from '@tanstack/react-router';
import { useEffect } from 'react';

/**
 * 로그인 이후 모든 화면의 공통 레이아웃 — GNB + 본문
 * Figma 화면 프레임: 배경 surface-grey(#f5f7f9) · GNB 아래 24 · 본문 폭 1200(1440에서 좌우 120) · 아래 80
 */
export const AppLayout = () => {
  const refreshMe = useAuthStore((s) => s.refreshMe);

  // 새로고침 · 재방문 시 /auth/me로 닉네임 · 영업 승인 상태를 다시 받는다.
  // 실패(401)는 http-client가 재발급 · 재로그인으로 처리한다.
  useEffect(() => {
    void refreshMe().catch(() => undefined);
  }, [refreshMe]);

  return (
    <div className="min-h-dvh bg-surface-grey">
      <Gnb />
      <main className="px-4 pt-5 pb-10 lg:px-10 lg:pt-6 lg:pb-20">
        <div className="mx-auto max-w-[1200px]">
          <Outlet />
        </div>
      </main>
      <PrescriptionUploadHost />
    </div>
  );
};
